/** Reserve Taxes & Service Charge (same payload shape). */
export const RESERVE_TAX_ROW_TYPE_KEY = "Tax Type";
export const RESERVE_TAX_ROW_VALUE_KEY = "Value";
export const RESERVE_TAX_ROW_LEGACY_TAX_NAME_KEY = "Tax Name";

/** DnD Code / Name columns used on multiple Reserve list screens. */
export const RESERVE_DND_CODE_KEY = "Code";
export const RESERVE_DND_NAME_KEY = "Name";

/** Reserve Location (Activities) */
export const RESERVE_LOCATION_AREA_KEY = "Area";
export const RESERVE_LOCATION_TYPE_KEY = "Location Type";

/** Reserve Tables (Dining) */
export const RESERVE_TABLES_SEATING_AREA_KEY = "Seating Area";
export const RESERVE_TABLES_SEATING_TYPE_KEY = "Seating Type";

/** Reserve Rate Plan */
export const RESERVE_RATE_PLAN_ACTIVITY_NAME_KEY = "Special Meal";
export const RESERVE_RATE_PLAN_BASE_PRICE_KEY = "Base Price";
export const RESERVE_RATE_PLAN_GUEST_TYPE_PRICING_KEY = "Guest Type Pricing";
export const RESERVE_RATE_PLAN_HOURLY_PRICE_KEY =
  "Hourly Price (if Applicable)";
export const RESERVE_RATE_PLAN_DAILY_WEEKLY_KEY = "Daily/Weekly";

/** Reserve Instructors */
export const RESERVE_INSTRUCTORS_SR_NO_KEY = "Sr. No";
export const RESERVE_INSTRUCTORS_LINE_KEY = "Name - Instructor Level";
export const RESERVE_INSTRUCTORS_LEGACY_NAME_KEY = "Name";
export const RESERVE_INSTRUCTORS_LEGACY_CODE_KEY = "Code";
/** Expertise level select values (payload / UI). */
export const RESERVE_INSTRUCTORS_EXPERTISE_NONE = "None";
export const RESERVE_INSTRUCTORS_EXPERTISE_TRAINER = "Trainer";
export const RESERVE_INSTRUCTORS_EXPERTISE_OPTIONS = [
  RESERVE_INSTRUCTORS_EXPERTISE_NONE,
  RESERVE_INSTRUCTORS_EXPERTISE_TRAINER,
] as const;
export const RESERVE_COUNTRY_CODE_MAX_DIGITS = 4;
